<template>
  <div class>
    <div class="row mb5 mt15">
      <div class="col-md-3">
        <div class="form-group">
          <!-- <input type="text" v-model="searchParams.sectorname"   @change="getGroupData"  class="form-control" name="sector" placeholder="Search by Sector"/> -->
          <select class="form-control" name="sector" v-model="selInd" @change="getGroupData">
            <option value>Select Index</option>
            <option
              v-for="(pr, index) in priceVsIndexList"
              :value="index"
              v-bind:key="'group'+index"
            >{{getLabel(pr.Group)}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <v-multiselect
            v-model="selComps"
            :options="companyList"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Select Portfolio"
            label="companyname"
            track-by="companyname"
            :preselect-first="true"
            select-label=""
            selectedLabel=""
            deselectLabel
            :max-height="500"
          >
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span
                class="multiselect__single"
                v-if="values.length && !isOpen"
          >{{values.length}} selected</span>
           </template>
          </v-multiselect>
        </div>
      </div>
      <div class="col-md-1">
        <div class="form-group">
          <button class="form-control btn btn-sm btn-success" type="button" @click="getUpdatedGroupData">Go</button>
        </div>
      </div>      
      <div class="col-md-2">
        <div class="form-group">
          <button v-if="comPriceData.length>0" class="form-control btn btn-sm btn-primary" type="button" @click="updatePortfolio">Update</button>
        </div>
      </div>
      <div class="col-md-1" v-if="comPriceData.length>0">
        <div class="form-group">
          <button class="form-control btn btn-sm btn-danger" type="button" @click="remove">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-2">{{getLabel(portData.group)}}</div>
      <div class="col-md-1">
        <div v-if="comPriceData.length>0">
          <download :tableId="'extportfolio'+portId" :fileName="'indices-vs-portfolio'+(portId+1)"></download>
        </div>
      </div>
      <div class="col-md-2">
        <span v-if="comPriceData.length>0">
          <span class="text-bold">
            Weightage:
            <br>
          </span>
          {{weightage}} %
        </span>
      </div>
      <div class="col-md-2">
        <span v-if="comPriceData.length>0">
          <span class="text-bold">
            Indices Return:
            <br>
          </span>
          {{getFixed(groupData[groupData.length-1]-groupData[0])}} %
        </span>
      </div>
      <div class="col-md-2">
        <span v-if="comPriceData.length>0">
          <span class="text-bold">
            Portfolio Return:
            <br>
          </span>
          {{getFixed(comPriceData[comPriceData.length-1]-comPriceData[0])}} %
        </span>
      </div>
      <div class="col-md-3" v-if="allComPriceData.length>0">
        <span v-for="(d, index) in duration" v-bind:key="d.id+d.name">
          <button
            type="button"
            @click="getDurationData(index)"
            class="btn btn-sm mb5"
            :class="(d.active)? 'btn-primary': 'btn-outline-secondary'"
            style="padding: 0.2rem;"
          >{{d.name}}</button>
        </span>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-3">
        <div
          class="table-responsive" v-dragscroll="true"
          v-if="portData.company_name !== '' || portData.company_name.length>0"
        >
          <table class="table">
            <thead>
              <tr>
                <th>Selected Companies</th>
              </tr>
            </thead>
            <tr v-for="(co, ind) in selComps" v-bind:key="co.co_code">
              <td>{{co.companyname}}</td>
              <td><i @click="removeComp(ind)" class="fa fa-remove flat-color-4"></i></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-md-9" :id="'existingPortfolioChart'+portId">
        <canvas :id="'existingPortfolio'+portId"></canvas>
      </div>
    </div>
    <div v-show="false">
      <table class="table" :id="'extportfolio'+portId">
        <thead v-if="chartIndicesData.index">
          <tr>
            <th>Date</th>
            <th>{{portData.group}}</th>
            <th>{{portData.group}} (Converted)</th>
            <th v-for="(cp, cind, keyi) in portData.company_name" :key="'port'+cind">
              {{cp}}
            </th>
            <th>
              Combined Converted
            </th>
          </tr>
        </thead>
        <tbody v-if="chartIndicesData.index">
          <tr v-for="(ac, acind, key) in chartIndicesData.index.series" :key="'portlabel'+acind" v-if="acind >= startInd">
            <td>{{getDate(ac["my_date"])}}</td>
            <td>{{ac["value"]}}</td>
            <td>{{groupData[acind]}}</td>
            <td v-for="(cp, cind) in companyPrices" :key="'port'+cind+acind">
              <span v-if="cp && cp[acind]">{{cp[acind][1]}}</span>
              <span v-else>{{"-"}}</span>
            </td>
            <td>
              {{comPriceData[acind]}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import http from "@/lib/http";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { commonMixins } from "@/assets/mixins/common.js";

export default {
  mounted() {},
  mixins: [commonMixins],
  props: ["portId", "portData", "companyList", "priceVsIndexList"],
  created() {
    console.log("portId", this.portId, this.portData, this.priceVsIndexList, this.companyList);
    // this.selInd = this.portData.group;
    this.getIndicesIndex();    
    this.compCodes = Object.keys(this.portData.company_price);
    this.getSelectedCompanies();
    this.getGroupData();
  },
  data() {
    return {
      chartIndicesData: [],
      downloadData: [],
      convertedGroupData: [],
      convertedComPriceData: [],
      groupLabels: [],
      groupData: [],
      compPriceLables: [],
      comPriceData: [],
      allComPriceData: [],
      selChart: "",
      selInd: "",
      chartIndexData: {},
      graphOptions: {
        maintainAspectRatio: true,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              // ticks: {
              //   beginAtZero: true
              // },
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      },
      isChartdataLoading: 0,
      companyPrices: [],
      selComps: [],
      compCodes: [],
      duration: [
        { id: "1m", name: "1M", active: 0, duration: 0 },
        { id: "3m", name: "3M", active: 0, duration: 3 },
        { id: "6m", name: "6M", active: 0, duration: 6 },
        { id: "1y", name: "1Y", active: 0, duration: 12 },
        { id: "3Y", name: "3Y", active: 0, duration: 36 },
        { id: "5Y", name: "5Y", active: 0, duration: 60 },
        { id: "10Y", name: "10Y", active: 1, duration: 120 }
      ],
      selDur: 6,
      startInd: 0,
      weightage: 100
    };
  },
  methods: {
    getGroupData() {
      console.log(
        "Chartdata loading",
        this.isChartdataLoading,
        this.isChartdataLoading === 0
      );
      if (this.isChartdataLoading === 0) {
        this.duration[this.selDur].active = 0;
        this.selDur = 6;
        this.duration[this.selDur].active = 1;
        (this.groupData = []),
          (this.groupLabels = []),
          (this.chartIndicesData = []);
        (this.comPriceData = []),
          (this.allComPriceData = []),
          (this.companyPrices = []),
          (this.compPriceLables = []);
        this.convertedGroupData = [];
        this.convertedComPriceData = [];
        this.startInd = 0;
        this.weightage = (100 / (this.compCodes).length).toFixed(2);
        this.isChartdataLoading = 1;
        this.isChartdataLoading = 0;
        console.log("chartdata", this.portData);
        this.chartIndicesData = this.portData;
        this.chartIndicesData.index.series.forEach((val, key) => {
          this.groupLabels.push(val["my_date"]);
          this.groupData.push(val["value"]);
        });
        this.groupData = this.getDataInRatio(this.groupData);
        console.log("GroupLabels", this.groupData, this.groupLabels);
        this.companyPrices = this.portData.company_price;
        this.compCodes.forEach((sVal, sKey) => {
          console.log();
          this.allComPriceData.push(this.portData.company_price[sVal]);
        });
        setTimeout(() => {
          this.companiesVsIndices();
        });
      }
    },
    getUpdatedGroupData() {
      console.log(
        "Chartdata loading",
        this.isChartdataLoading,
        this.isChartdataLoading === 0
      );
      if (this.isChartdataLoading === 0) {
        this.duration[this.selDur].active = 0;
        this.selDur = 6;
        this.duration[this.selDur].active = 1;
        (this.groupData = []),
          (this.groupLabels = []),
          (this.chartIndicesData = []);
        (this.comPriceData = []),
          (this.allComPriceData = []),
          (this.companyPrices = []),
          (this.compPriceLables = []);
          this.convertedGroupData = [];
          this.convertedComPriceData = [];
          this.startInd = 0;
        if (this.selInd !== '' && this.selComps !== '') {          
        this.selComps = this.sorted_fields_asc(this.selComps, 'co_code');
          var compCodes = [];
          this.selComps.forEach((sVal, sKey) => {
            compCodes.push(sVal.co_code);
          });
          this.weightage = (100/compCodes.length).toFixed(2);
          this.isChartdataLoading = 1;
          http.post(
            "getIndicesRatiosExchangeWise",
            {
              exchange: this.priceVsIndexList[this.selInd].Exchange,
              index_code: this.priceVsIndexList[this.selInd].indexcode,
              group: this.priceVsIndexList[this.selInd].Group,
              co_code: compCodes
            },
            (error, response) => {
              this.isChartdataLoading = 0;
              this.chartIndicesData = response;
              this.chartIndicesData.index.series.forEach((val, key) => {
                // this.groupLabels.push(val["my_date"].substring(0, val["my_date"].indexOf("T")));
                this.groupLabels.push(val["my_date"]);
                this.groupData.push(val["value"]);
              });
              this.groupData = this.getDataInRatio(this.groupData);
              this.companyPrices = response.company_price;
              this.selComps.forEach((sVal, sKey) => {
                this.allComPriceData.push(response.company_price[sVal.co_code]);
              });
              setTimeout(() => {
                this.companiesVsIndices();
              }, 200);
              // this.plotGraph();
            }
          );
        } else {
          console.log("One of this not selected");
          this.isChartdataLoading = 0;
          var emptyData =
            this.selInd === "" && this.selComps === ""
              ? "Indices & Company"
              : this.selInd === ""
              ? "Indices"
              : this.selComps === ""
              ? "Company"
              : "";
              console.log("emptyData", emptyData);
          this.$toastr.error("Please select " + emptyData, "",{});
        }
      }
    },
    companiesVsIndices() {
      var firstData;
      this.allComPriceData[0].forEach((val, key) => {
        // console.log(val, key);
        this.compPriceLables.push(val[0]);
        if (key === 0) {
          firstData = key;
          this.comPriceData.push(100);
          // this.json_data.push({data: 100, date: val[0]});
        } else {
          var compPrice = 0;
          // console.log("ALLDATA", this.allComPriceData);
          for (let i = 0; i < this.selComps.length; i++) {
            // console.log(i, key);
            if (this.allComPriceData[i][key]) {
              var compPrice1 = parseFloat(
                (100 * parseFloat(this.allComPriceData[i][key][1])) /
                  parseFloat(this.allComPriceData[i][firstData][1])
              );
            }
            // console.log(parseFloat(compPrice1));
            compPrice =
              parseFloat(compPrice) +
              parseFloat(compPrice1 * (1 / this.selComps.length));
            // console.log(parseFloat(compPrice));
          }
          this.comPriceData.push(compPrice.toFixed(2));
        }
      });
      this.convertedGroupData = this.groupData;
      this.convertedComPriceData = this.comPriceData;
      this.plotGraph();
    },
    getDurationData(ind) {
      this.startInd = 0;
      this.duration[this.selDur].active = 0;
      this.duration[ind].active = 1;
      this.selDur = ind;
      var durDate = new Date();
      var curDate = new Date();
      durDate = this.minusMonths(
        new Date(curDate.getFullYear(), curDate.getMonth(), "01"),
        this.duration[ind].duration
      );
      this.getDataForDuration(curDate, durDate);
    },
    getDataForDuration(curDate, durDate) {
      (this.groupData = []), (this.groupLabels = []);
      // console.log("this.selInd", this.selInd);
      this.chartIndicesData.index.series.forEach((val, key) => {
        var ddate = new Date(val["my_date"]); //.substring(0, val["my_date"].indexOf("T")));
        // console.log(ddate, ddate > durDate);
        if (ddate > durDate) {
          if (this.startInd === 0) {
            this.startInd = key;
          }
          this.groupLabels.push(val["my_date"]); //.substring(0, val["my_date"].indexOf("T")));
          this.groupData.push(val["value"]);
        }
      });
      console.log("GroupLabels", this.groupData, this.groupLabels);
      console.log("All Prices", this.allComPriceData, this.selComps);
      this.groupData = this.getDataInRatio(this.groupData);
      (this.comPriceData = []), (this.compPriceLables = []);
      var comActPrice = [];
      var firstData;
      this.allComPriceData[0].forEach((val, key) => {
        // console.log(val, key, (key === 0));
        var ddate = new Date(val[0]);
        // console.log(ddate, ddate > durDate);
        if (ddate > durDate) {
          this.compPriceLables.push(val[0]);
          if (this.comPriceData.length === 0) {
            this.comPriceData.push(100);
            firstData = key;
            comActPrice.push(val[1]);
          } else {
            var compPrice = 0;
            for (let i = 0; i < this.selComps.length; i++) {
              if (
                this.allComPriceData[i][key] &&
                this.allComPriceData[i][key].length > 0 &&
                this.allComPriceData[i][firstData].length > 0
              ) {
                var compPrice1 = parseFloat(
                  (100 * parseFloat(this.allComPriceData[i][key][1])) /
                    parseFloat(this.allComPriceData[i][firstData][1])
                );
                // console.log(parseFloat(compPrice1));
                compPrice =
                  parseFloat(compPrice) +
                  parseFloat(compPrice1 * (1 / this.selComps.length));
                // console.log(parseFloat(compPrice));
              }
            }
            comActPrice.push(val["value"]);
            this.comPriceData.push(compPrice.toFixed(2));
            // console.log(
            //   firstData,
            //   ddate,
            //   ddate > durDate,
            //   key,
            //   compPrice,
            //   compPrice1,
            //   this.comPriceData,
            //   this.selComps.length
            // );
          }
        }
      });
      // console.log(comActPrice);
      // });
      // console.log("this.comPriceData", this.comPriceData);
      this.configureChart();
    },
    plotGraph() {
      setTimeout(() => {
        this.configureChart();
      }, 100);
    },
    configureChart() {
      this.graphOptions["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      // var ctx = document.getElementById("existingPortfolio").getContext("2d");
      var existingPortfolioChart = document.getElementById(
        "existingPortfolioChart" + this.portId
      );
      var portId = this.portId;
      existingPortfolioChart.innerHTML = "&nbsp;";
      $("#existingPortfolioChart" + portId).append(
        '<canvas id="existingPortfolio' + portId + '"><canvas>'
      );

      var ctx = $("#existingPortfolio" + portId)
        .get(0)
        .getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.groupLabels,
          datasets: [
            {
              label: this.portData.group,
              backgroundColor: "transparent",
              borderColor: "rgb(81, 143, 212)",
              pointBackgroundColor: "#ffffff",
              data: this.groupData
            },
            {
              label: "Portfolio",
              backgroundColor: "transparent",
              borderColor: "rgb(227, 175, 100)",
              pointBackgroundColor: "#ffffff",
              data: this.comPriceData
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart.update();
    },
    remove() {
      this.$emit("removePortfolio", { portId: this.portId });
    },
    removeComp(ind) {
      console.log("remove", ind);
      this.selComps.splice(ind, 1);
    },
    updatePortfolio(){
      console.log('company codes', this.selComps);
      var compCodes = [];
      this.selComps.forEach((sVal, sKey) => {
        compCodes.push(sVal.co_code);
      });
      http.post(
        "savePortfolios",
        {
          exchange: this.priceVsIndexList[this.selInd].Exchange,
          index_code: this.priceVsIndexList[this.selInd].indexcode,
          group: this.priceVsIndexList[this.selInd].Group,
          co_code: compCodes,
          _id: this.portData._id
        },
        (error, response) => { 
          if(response.ok===1){
            this.$toastr.success("Portfolio updated successfully!",{});
            this.isSaved = true;
          } else { this.isSaved = false; }
        });
    },
    getIndicesIndex(){
      this.priceVsIndexList.forEach((val, key) => {
        if(this.portData.group === val.Group){
          this.selInd = key;
          return;
        }
      });
    },
    getSelectedCompanies(){
      this.companyList.forEach((val, key) => {
        if(this.checkInArray(this.compCodes, val.co_code)){
          this.selComps.push(val);
        }
      });
    }
  },
  mounted() {},
  watch: {
    priceVsIndexList: function(value) {
      if (value.length > 0) {
        this.getIndexOfObject();
      }
    },
    companyList: function(value) {
      if (value.length > 0) {
      }
    },
    portData: function(value) {
      console.log("portdata", value);
      this._chart.destroy();
      if (value.company_price) {
        this.getGroupData();
      }
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table th.column-sort {
  cursor: pointer;
}

.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/indices-data/portfolio.vue